import { render, staticRenderFns } from "./pg-auth.vue?vue&type=template&id=35d0581c&scoped=true"
import script from "./pg-auth.vue?vue&type=script&lang=js"
export * from "./pg-auth.vue?vue&type=script&lang=js"
import style0 from "./pg-auth.vue?vue&type=style&index=0&id=35d0581c&prod&lang=css"
import style1 from "./pg-auth.vue?vue&type=style&index=1&id=35d0581c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0581c",
  null
  
)

export default component.exports